import { root } from '@estee/elc-universal-utils';

export const getSearchParam = (searchKey: string) => {
    const search = (<Location>root.location).search;
    const searchParams = new URLSearchParams(search);

    return searchParams.get(searchKey);
};
